import Backbone from 'backbone';
import _ from 'underscore';

import Paginator from './Paginator';

export default class TastypieCollection extends Backbone.Collection {
  initialize(options) {
    this.paginator = new Paginator({}, this);
  }

  destroyAll(options) {
    var payload = {
      'objects': [],
      'deleted_objects': []
    };

    this.forEach(function(model) {
      payload.deleted_objects.push(model.get('resource_uri'));
    });

    var collection = this;

    options.success = function(resp) {
      var size = collection.size();
      for (var i = size - 1; i >= 0 ; i--) {
        var model = collection.at(i);
        model.trigger('destroy', model, model.collection);
      }
    };

    var syncOptions = _.extend({'attrs': payload }, options);
    return Backbone.sync('patch', this, syncOptions);
  }

  parse(response) {
    this.paginator.set(response.meta);
    return response.objects || response;
  }

  patch(values, options) {
    if (!options) {
      options = {};
    }

    var payload = {
      'objects': [],
      'deleted_objects': []
    };

    var valid = true;

    this.forEach(function(model) {
      var modelData = model.changedAttributes() || {};

      if (values) {
        modelData = _.extend(modelData, values);
      }

      if (_.size(modelData) > 0) {
        modelData.resource_uri = model.get('resource_uri');
        payload.objects.push(modelData);
      }
    });

    var collection = this;

    options.success = function(resp) {
      options = {
        add: false,
        remove: false,
        parse: true
      };
      collection.set(resp, options);
      collection.trigger('sync', collection, resp, options);
    };

    if (valid) {
      options = _.extend({'attrs': payload }, options);
      return Backbone.sync('patch', this, options);
    }
    return false;
  }
}


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/backbone/models/TastypieCollection.js
 **/